import { Typography } from "@material-ui/core"
import PageBreadcrumbs from "components/lobbypage/components/PageBreadcrumbs"
import styled from "styled-components"
import colors from "theme/colors"
import { fontCondensed } from "theme/GlobalStyle"

const StyledDescriptionWrapper = styled.div`
  /* ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0 16px;
  } */

  ${(p) => p.theme.breakpoints.up("md")} {
  }
`

const StyledTitle = styled(Typography).attrs({
  component: "h1",
  variant: "h2",
})`
  font-size: 44px;
  font-weight: normal;
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 1;
  ${fontCondensed}
  color: ${colors.blackDark};
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 70px;
  }
`

const StyledSubtitle = styled(Typography).attrs({
  component: "p",
  variant: "h2",
})`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: normal;
`

const StyledDescription = styled(Typography).attrs({
  component: "div",
  variant: "body1",
})`
  margin-bottom: 10px;
  margin-top: 0;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.black};
  white-space: break-spaces;
  line-height: 1.57;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 20px;
  }
  p {
    /* line-height: 1.2; */
    margin: 0;
  }

  a {
    text-decoration: underline;
  }
  ul {
    margin: 0.5em 0;
    padding-inline-start: 1.3em;
    li::marker {
      color: ${({ theme }) => theme.colors.red};
    }
  }
`

//to remove

export type DataContentProps = {
  title: string
  subtitle?: string
  description: string
}

type DataProps = {
  data: DataContentProps
  parentPageType?:
    | "assets-list"
    | "about"
    | "investor-relations"
    | "investments"
}

const Description = ({ data, parentPageType }: DataProps) => {
  return (
    <StyledDescriptionWrapper>
      <PageBreadcrumbs
        thisPageName={data.title}
        parentPageType={parentPageType}
      />
      <StyledTitle>{data.title}</StyledTitle>
      {data.subtitle && <StyledSubtitle>{data.subtitle}</StyledSubtitle>}

      <StyledDescription
        dangerouslySetInnerHTML={{ __html: data?.description }}
      ></StyledDescription>
    </StyledDescriptionWrapper>
  )
}

export default Description
